export default {
  toggle: {
    border: {
      style: 'solid',
      thickness: '0.0625rem',
    },
    padding: {
      vertical: '0.75rem',
      horizontal: '0.9375rem',
    },
    arrow: {
      width: '0.328125rem',
      height: '0.46875rem',
    },
  },
  options: {
    border: {
      bottom: {
        style: 'solid',
        thickness: '0.0625rem',
      },
    },
    maxHeight: '13.75rem',
  },
  option: {
    border: {
      style: 'solid',
      thickness: '0.0625rem',
    },
    padding: {
      vertical: '0.625rem',
      horizontal: '0.9375rem',
    },
    active: {
      font: {
        weight: 800,
      },
    },
    searchResult: {
      fontSize: '0.8125rem',
      padding: '1rem',
    },
  },
};
